// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GOdjZbyIUlFQLq {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.A7BMzbrOgQdtLw {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.uHwxFIcWkXR6mA {
  padding: var(--ds-space-400, 32px) 140px var(--ds-space-500, 40px) 140px;
  text-align: center;
}
.K90JhvJHZs356S {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.ACmzENWWnTx_hs {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.ACmzENWWnTx_hs:hover,
.ACmzENWWnTx_hs:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaWelcomeModal = `GOdjZbyIUlFQLq`;
export var headingImage = `A7BMzbrOgQdtLw`;
export var contentContainer = `uHwxFIcWkXR6mA`;
export var ctasContainer = `K90JhvJHZs356S`;
export var closeButton = `ACmzENWWnTx_hs`;
export default ___CSS_LOADER_EXPORT___;
